import React, {Component, PropTypes} from 'react';
import Field from '../Field';
import SubmitInput from '../Fields/SubmitInput';
import HeaderSteps from '../Fragments/HeaderSteps';
import { browserHistory } from 'react-router';
import FullPageSpinner from '../Fragments/FullPageSpinner';
import SaveForLaterModal from '../Fragments/SaveForLaterModal';

let Quote = require('../Managers/Quote');
let addressHistoryMonths = 0;
let Config = require('Config');
let HttpService = require('../Managers/HttpService');

export default class TenantDetails extends Component {
    static propTypes = {
        source: PropTypes.string,
    }

    static defaultProps = {
        source: 'BaseIndividualApplication',
    }

    constructor(props) {
        super(props);
        this.state = {
            addressHistoryLength: 0,
            tenantNumber: 1,
            isPreviousAddressNeeded: false,
            isOtherAddressNeeded: false,
            totalOccupancyPeriod: 0,
            isOtherTitleNeeded: false,
            isFullPageSpinnerActive: false,
            isInsightExpressForeignWarningDisplayed: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    /**
     * Checks the total occupancy in months for the current address. If it is
     * under 36 months, then a second address history entry is required.
     *
     * @param v
     */
    checkIfPreviousAddressNeeded(v) {
        addressHistoryMonths = v;
        if (v < 36) {
            this.setState({
                isPreviousAddressNeeded: true,
                totalOccupancyPeriod: v,
            });
        } else {
            this.setState({
                isPreviousAddressNeeded: false,
                totalOccupancyPeriod: v,
            });
            Quote.deleteByPath('BaseIndividualApplication', 'addressHistories.1');
        }

        this.setState({ totalOccupancyPeriod: this.addUpAllAddressHistories() });
    }

    /**
     * Checks against total occupancy period provided for current and previous
     * addresses. If still under 36 months in total, then another address
     * history entry is required.
     *
     * @param v total occupancy months against current and previous address
     */
    checkIfOtherAddressNeeded(v) {
        let t = v + addressHistoryMonths;
        if (t < 36) {
            this.setState({ isOtherAddressNeeded: true });
        } else {
            this.setState({ isOtherAddressNeeded: false });
            Quote.deleteByPath('BaseIndividualApplication', 'addressHistories.2');
        }

        this.setState({ totalOccupancyPeriod: this.addUpAllAddressHistories() });
    }

    addUpAllAddressHistories() {
        let total = 0;
        if (Quote.getByPath('BaseIndividualApplication.addressHistories.2.durationMonths')) {
            total = parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.2.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths'));
        } else if (Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths')) {
            total = parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths'));
        } else if (Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) {
            total = parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths'));
        }

        return total;
    }

    checkIfOtherTitleNeeded(v) {
        if (Config.standardTitles.indexOf(v.toUpperCase()) === -1) {
            this.setState({ isOtherTitleNeeded: true });
        } else {
            this.setState({ isOtherTitleNeeded: false });
        }
    }

    // todo: gross manual step transitions until we have a step manager
    manualStepProgression() {
        let productId = parseInt(Quote.getByPath('BaseIndividualApplication.product.productId'));
        let referenceType = parseInt(Quote.getByPath('BaseIndividualApplication.referenceType'));
        this.setState({ isFullPageSpinnerActive: true });

        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            this.setState({ isFullPageSpinnerActive: false });
            if (document.querySelectorAll('.has-error').length > 0) {
                this.setState({ isInsightExpressForeignWarningDisplayed: false });
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else if ((productId === 20 || productId === 11 || (productId === 24 && referenceType === 1)) && this.state.totalOccupancyPeriod < 6) {
                // Less than 6months total occupancy AND (Insight OR Xpress OR Inspire Credit Check)
                this.setState({ isInsightExpressForeignWarningDisplayed: true });
                $('html, body').animate({
                    scrollTop: $("#foreign-warning").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                this.setState({ isInsightExpressForeignWarningDisplayed: false });
                if (productId === 20 || (productId === 24 && referenceType === 1)) {
                    // Insight application
                    browserHistory.push('/application/additional-details');
                } else if (Quote.getByPath('BaseIndividualApplication.applicationType') === 2 || productId === 11) {
                    // Guarantor application or Xpress
                    browserHistory.push('/application/your-finances');
                } else {
                    browserHistory.push('/application/your-landlord');
                }
            }
        }, 1000);
    }

    render() {
        let productId = parseInt(Quote.getByPath('BaseIndividualApplication.product.productId'));
        let referenceType = parseInt(Quote.getByPath('BaseIndividualApplication.referenceType'));
        return(
            <div>
                <HeaderSteps current={2} />

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <question-row class="header-row" id="step-title">
                    <h1>Your personal details</h1>
                </question-row>

                {this.state.isInsightExpressForeignWarningDisplayed === true ?
                    <div className="flash error" id="foreign-warning">
                        <p><strong>Attention:</strong> You must have lived in the UK for the past 6 months in order to continue.</p>
                    </div>
                : null}

                <Field
                    fieldName={'tenantTitle'}
                    question="Title"
                    storageKey="title"
                    type="button-choice"
                    options={[
                        {
                            value: 'Mr',
                            text: 'Mr'
                        },
                        {
                            value: 'Mrs',
                            text: 'Mrs'
                        },
                        {
                            value: 'Miss',
                            text: 'Miss'
                        },
                        {
                            value: 'Ms',
                            text: 'Ms'
                        },
                        {
                            value: 'Mx',
                            text: 'Mx'
                        },
                        {
                            value: 'Dr',
                            text: 'Dr'
                        },
                    ]}
                    otherOptions={{
                        onOtherCallback: () => {
                            this.setState({ isOtherTitleNeeded: true });
                        },
                        offOtherCallback: () => {
                            this.setState({ isOtherTitleNeeded: false });
                        },
                        clearValueOnOther: true
                    }}
                    dataValidation="required_field"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                {this.state.isOtherTitleNeeded === true ?
                    <Field
                        fieldName={'otherTitle'}
                        question="Other title"
                        storageKey="title"
                        type="text"
                        maxLength={24}
                        dataValidation="required_field"
                        source="BaseIndividualApplication"
                        loadValues={true}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                : null}
                <Field
                    fieldName={'firstName'}
                    question="First name"
                    storageKey="firstName"
                    type="text"
                    maxLength={35}
                    dataValidation="alpha_and_space_only"
                    source={this.props.source}
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    forcibleValidation
                />
                <Field
                    fieldName={'middleName'}
                    question="Middle name"
                    storageKey="middleName"
                    type="text"
                    maxLength={35}
                    dataValidation="alpha_and_space_only.non_mandatory"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    fieldName={'lastName'}
                    question="Last name"
                    storageKey="lastName"
                    type="text"
                    maxLength={35}
                    dataValidation="alpha_and_space_only"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    forcibleValidation
                />
                <Field
                    fieldName={'previousName'}
                    question="Previous or maiden name(s)"
                    storageKey="otherName"
                    type="text"
                    maxLength={35}
                    dataValidation="alpha_and_space_only.non_mandatory"
                    helpText="Please provide any other names you have been known by legally."
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    type="date"
                    subType="dob"
                    fieldName={'dateOfBirth'}
                    question="Date of birth"
                    storageKey="birthDate"
                    dataValidation="date_of_birth_at.mandatory"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <question-row class="header-row">
                    <h2>Your contact details</h2>
                </question-row>
                <Field
                    type="text"
                    maxLength={11}
                    fieldName={'mobileNumber'}
                    question="Mobile number"
                    storageKey="mobile"
                    dataValidation="mobile_number.non_mandatory"
                    helpText="If you provide a mobile number, it will help speed up the application process, and you will receive valuable updates"
                    labelExtra="Mobile number is used to send updates on the application, this must be a UK based number"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    type="email"
                    fieldName={'emailAddress'}
                    question="Email address"
                    storageKey="email"
                    dataValidation="email_address"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    type="text"
                    maxLength={20}
                    fieldName={'phoneNumber'}
                    question="Other telephone number"
                    storageKey="phone"
                    dataValidation="phone_number"
                    source="BaseIndividualApplication"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <question-row class="header-row">
                    <h2>Your address details</h2>
                </question-row>
                <Field
                    type="address"
                    fieldName={'current_'}
                    question="Current address postcode"
                    storageKey="address"
                    helpText="It is important address history is entered correctly"
                    labelExtra={productId === 20 || productId === 11 || (productId === 24 && referenceType === 1) ? 'You need to have been living in the UK for the last six months in order to complete a reference.' : null}
                    addressOptions={{
                        canHaveManualEntry: false,
                        canBeForeign: productId === 20 || productId === 11 || (productId === 24 && referenceType === 1) ? false : true,
                        pafLookup: true,
                    }}
                    source="BaseIndividualApplication.addressHistories.0.address"
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.addressHistories.0.address'}
                    ref={(instance) => {
                        this.inputComponents.push(instance);
                        this.childComponents.push(instance);
                    }}
                />
                <Field
                    fieldName={'currentAddressPeriod'}
                    question="How long have you been living at this address?"
                    storageKey="durationMonths"
                    type="date"
                    hasBorder={false}
                    subType="year-month"
                    limitMonths={true}
                    callbackFunction={this.checkIfPreviousAddressNeeded.bind(this)}
                    source="BaseIndividualApplication.addressHistories.0"
                    dataValidation="duration_months_tenancy"
                    loadValues={true}
                    hasPadding={false}
                    loadingKey={'BaseIndividualApplication.addressHistories.0.durationMonths'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                {this.state.isPreviousAddressNeeded === true ?
                    <div>
                        <Field
                            type="address"
                            fieldName={'previous_'}
                            question="Previous address postcode"
                            labelExtra={(productId === 20 || productId === 11 || (productId === 24 && referenceType === 1)) && parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) < 6 ? 'You need to have been living in the UK for the last six months in order to complete a reference. So far you have entered ' + Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths') + ' months in the UK.' : 'You need to enter 3 years worth of addresses or last 3 addresses'}
                            storageKey="address"
                            addressOptions={{
                                canHaveManualEntry: false,
                                canBeForeign: (productId === 20 || productId === 11 || (productId === 24 && referenceType === 1)) && parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) < 6  ? false : true,
                                pafLookup: true,
                            }}
                            source="BaseIndividualApplication.addressHistories.1.address"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.addressHistories.1.address'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'previousAddressPeriod'}
                            question="How long were you living at this address?"
                            storageKey="durationMonths"
                            type="date"
                            hasBorder={false}
                            hasPadding={false}
                            subType="year-month"
                            callbackFunction={this.checkIfOtherAddressNeeded.bind(this)}
                            source="BaseIndividualApplication.addressHistories.1"
                            dataValidation="duration_months_tenancy"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.addressHistories.1.durationMonths'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                    </div>
                : null}
                {this.state.isOtherAddressNeeded === true ?
                    <div>
                        <Field
                            type="address"
                            fieldName={'other_'}
                            question="Second previous address postcode"
                            storageKey="address"
                            labelExtra={(productId === 20 || productId === 11 || (productId === 24 && referenceType === 1)) && (parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths'))) < 6 ? 'You need to have been living in the UK for the last six months in order to complete a reference. So far you have entered ' + (parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths'))) + ' months in the UK.' : null}
                            addressOptions={{
                                canHaveManualEntry: false,
                                canBeForeign: (productId === 20 || productId === 11 || (productId === 24 && referenceType === 1)) && (parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.0.durationMonths')) + parseInt(Quote.getByPath('BaseIndividualApplication.addressHistories.1.durationMonths'))) < 6 ? false : true,
                                pafLookup: true,
                            }}
                            source="BaseIndividualApplication.addressHistories.2.address"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.addressHistories.2.address'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'otherPreviousAddressPeriod'}
                            question="How long were you living at this address?"
                            storageKey="durationMonths"
                            type="date"
                            hasBorder={false}
                            hasPadding={false}
                            subType="year-month"
                            source="BaseIndividualApplication.addressHistories.2"
                            dataValidation="duration_months_tenancy"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.addressHistories.2.durationMonths'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                    </div>
                : null}
                <question-row class="header-row">
                    <h2>Your bank details</h2>
                </question-row>
                <Field
                    fieldName={'sortcode'}
                    question="Sortcode"
                    storageKey="accountSortcode"
                    type="sortcode"
                    helpText="This will only be used for verification purposes. HomeLet will not take any payment from your account."
                    source="BaseIndividualApplication.bankAccount"
                    dataValidation={"sortcode.non_mandatory"}
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    type="text"
                    maxLength={17}
                    fieldName={'accountNumber'}
                    question="Account number"
                    storageKey="accountNumber"
                    dataValidation="bank_account.non_mandatory"
                    source="BaseIndividualApplication.bankAccount"
                    loadValues={true}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
                <Field
                    fieldName={'adverseCredit'}
                    question="In the last 6 years have you had any adverse credit, such as county court judgements, bankruptcies or insolvencies, whether satisfied or not?"
                    storageKey="hasCCJ"
                    type="button-choice"
                    options={[
                        {
                            value: true,
                            text: 'Yes'
                        },
                        {
                            value: false,
                            text: 'No'
                        }
                    ]}
                    dataValidation="required_field"
                    helpText={'It is important that you answer this correctly as this may affect the outcome of your application.'}
                    source="BaseIndividualApplication"
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.hasCCJ'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <SaveForLaterModal
                    ref="SaveForLaterModal"
                />

                <SubmitInput
                    label="Next"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    saveForLater={false}
                    saveForLaterFunc={() => {
                        this.setState({ isFullPageSpinnerActive: true });
                        HttpService.applicationPutApplication(() => {
                            this.setState({ isFullPageSpinnerActive: false });
                            this.refs.SaveForLaterModal.toggleIsActive();
                        });
                    }}
                    currentNumber={2}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/TenantsDetails.js